// extracted by mini-css-extract-plugin
export default {"login-page":"login_login-page__6qOwS","MuiInputBase-input":"login_MuiInputBase-input__hHeam","MuiOutlinedInput-notchedOutline":"login_MuiOutlinedInput-notchedOutline__02lep"};